import { v4 } from "uuid";
import { setChatId } from "./chatId";

/**
 * Start a fresh chat conversation by minting a new chat id.
 *
 * The backend keys its per-conversation TripContext (destination, dates,
 * travelers, active agent) on `_zenvoya_chat_id`. When the user starts a new
 * chat we MUST rotate this id — otherwise the brand-new conversation reuses
 * the previous chat's id and inherits its server-side context. Symptom: after
 * a hotel search, "start new chat" + a bare "Hi" re-runs the last hotel/flight
 * search with the old slots instead of greeting the user.
 *
 * @returns the freshly minted chat id.
 */
export function rotateChatId(): string {
  const chatId = v4();
  setChatId(chatId);
  return chatId;
}
